<template>
	<footer class="d-block px-3 px-md-3" :class="{'position-fixed': fixed}">
        <div class="d-flex justify-content-between">
            <div class="float-none float-md-left">
                <a href="#copyright" @click.prevent="$refs.modalCopyright.show()">
                    <span class="copyright font-weight-bold">Summar©{{new Date().getFullYear()}}</span>
                    <img src="https://summar.es/favicon.ico" title="Summar Software" class="pl-1" width="25">
                </a>
            </div>
            <FooterLinks :fixed="fixed"></FooterLinks>
        </div>
        
        <mmModal ref="modalCopyright" :textClose="$i18n.t('cerrar')" hide-header>
            <div class="d-block">
                <span><b>Summar Software ©{{new Date().getFullYear()}}</b><small>PW.DOC</small></span>
            </div>
        </mmModal>
    </footer>
</template>

<script>
    import FooterLinks from '@/views/layout/Footer-links';
    import mmModal from '@mysummar/summar-vue/src/components/mmModal.vue';

    export default {
        name: 'Footer',
        props: {
            fixed: Boolean
        },
        components: {
            FooterLinks,
            mmModal
        },
        data() {
            return {
                titlePolicy : '',
                txtPolicy : ''
            }
        }
    }
</script>

<style>
    
</style>